import dataManager from '@/plugins/dataManager'

const state = {
  clients: []
}

const getters = {
  getClients: (state) => {
    return state.clients
  }
}

const actions = {
  getClients (context) {
    return new Promise((resolve, reject) => {
      dataManager.get('clive', 'v1/client/', null).then(function (data) {
        context.commit('setClients', data)
        resolve(data)
      }).catch(function (err) {
        reject(err)
      })
    })
  }
}

const mutations = {
  setClients (state, clients) {
    state.clients = clients
  }
}
const namespaced = true
export default {
  namespaced,
  state,
  getters,
  actions,
  mutations
}
